import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import Link from 'valuelink';
import { showError } from '../../utils';
import { useState } from 'react';
import {
  Button,
  Col,
  Row,
  Select,
  Spin,
  Switch,
  message,
  TimePicker,
  Typography,
  Modal,
  Input as AntInput,
  Checkbox,
} from 'antd';

import moment from 'moment';
import { Input } from 'valuelink/lib/tags';
import { SemiboldText, ButtonText } from '../../components/common/Text';
import {
  updateNetworkCenterProfile,
  createNetworkCenterProfile,
  changeNetworkCenterStatus,
  uploadNetworkProfilePicture,
  removeCenterProfilePic,
  fetchLastSanitisationSpoc,
  createAddressCenterLatLong,
  updateNetworkCenterEmpanelment,
  sendWelcomeMailToCenter,
  updateNetworkCenterEmpanelUserStatus,
  checkCenterNetworkActivity,
  uploadMouDocument,
  centerActivationForPrebook,
} from '../../services';
import {
  fetchCenterBasicProfile,
  fetchCenterStates,
  sendRequestForDoctorDetailsChanges,
} from '../../services';
import UploadingComponent from '../../components/common/UploadingComponent';
import doctorPlaceholder from '../../images/common/placeholderDoctor.png';
import Tappable from 'react-tappable/lib/Tappable';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { getDentalPartners } from '../../services/api/cashless-dental';
import config from '../../../config';
const { Text, Title } = Typography;
const GOOGLE_MAPS_API_KEY = config.GOOGLE_MAPS_API_KEY;

const { Option } = Select;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const containerStyle = {
  width: '100%',
  height: '400px'
};

const center = {
  lat: 28.6139,  // New Delhi example
  lng: 77.2090
};

const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: '10px'
};

// CSS styles for input fields and labels
const styles = {
  inputContainer: {
    marginBottom: '15px',
  },
  label: {
    display: 'block',
    fontWeight: 'bold',
    marginBottom: '5px',
  },
  input: {
    width: '100%',
    padding: '8px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '14px',
  },
  errorText: {
    color: 'red',
    fontWeight: 'bold',
  },
  error: {
    color: 'red', // Red color for the error text
    fontSize: '12px', // Smaller font size
    fontWeight: '500', // Medium weight for better readability
    marginTop: '5px', // Space between input and error
  },
};

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  width: 100%;
  height: 44px;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 14px;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const StyledUploadingComponent = styled(UploadingComponent)`
  margin: 0;
`;

const ProfileImageTappable = styled(Tappable)`
  display: block;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const ProfileImage = styled.img`
  max-width: 100px;
  max-height: 100px;
  border-radius: 50px;
`;

class NetworkCenterBasicProfileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      title: '',
      address: '',
      locality: '',
      city: '',
      state: '',
      latitude: '',
      longitude: '',
      pincode: '',
      contactNumber: '',
      referenceId: '',
      description: '',
      servingSince: '',
      bedCapacity: '',
      type: '',
      opdStartsAt: moment('00:00:00', 'HH:mm:ss'),
      opdClosesAt: moment('00:00:00', 'HH:mm:ss'),
      networkSource: '',
      active: 0,
      states: [],
      profileImage: '',
      sanitisationStatus: 'pending',
      sanitisationSpoc: '',
      showRequest: 0,
      maternityCenter: false,
      approvalRequestModal: false,
      openWelcomeMailSendModal: false,
      deOnboardingReason: 'Tie-up issues',
      deOnboardedOn: null,
      dateDifference: 0,
      anyDoctorFlowStatus: false,
      empanelStatus: false,
      deOnboardingReason2: '',
      welcomeMailTriggerHistory: null,
      centerLogInPassword: null,
      centerUserName: null,
      prebookCenter: false,
      paymentCycle: null,
      empanelUserStatus: false,
      prebookCenterRequestModal: false,
      isCenterActivityAvailable: false,
      prebookModalLoader: false,
      callCenterNumber: '',
      website: '',
      selfBookSnapShot: null,
      mouLogIds: null,
      userConsent: 0,
      websiteError: null,
      callCenterNumberError: null,
      placeIdModal: false,
      suggestions: [],
      searchTerm: '',
      selectedLocation: {
        lat: 28.5681,
        lng: 77.3162,
      },
      placeId: '',
      cashlessProcedures: false,
      dentalNetwork: false,
      dentalPartnerId: null,
      dentalPartners: [],
    };

    this.centerId = props.centerId;
    this.isCenterEnabled = props.isCenterEnabled;
  }

  // address = () => {
  //   if (this.state.latitude != '' && this.state.longitude != '') {

  //   }
  //   const latitude = this.state.latitude;
  //   const longitude = this.state.longitude;

  //   createAddressCenterLatLong(latitude, longitude)
  //     .then((res) => {

  //       console.log(res)

  //     })
  //     .catch(err => {
  //       console.log(err);
  //     })
  // }
  componentDidMount = () => {
    if (this.centerId && this.centerId !== -1) {
      this.fetchProfile();
      this.fetchSanitisationSpoc();
    }
    this.fetchStates();
    this.fetchDentalPartners();
  };

  handleAttachment = () => {
    const { authToken } = this.props;
    const file = document.querySelector('#imageAttachment').files[0];
    if (file) {
      this.setState({
        uploading: true,
      });
      document.querySelector('#imageAttachment').value = null;
      const onUploadProgress = (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const { loaded, total } = progressEvent;
          this.setState({
            uploadProgress: (loaded / total) * 100,
          });
        } else {
          this.setState({
            uploadProgress: 100,
          });
        }
      };
      uploadNetworkProfilePicture(
        file,
        this.centerId,
        onUploadProgress,
        authToken
      )
        .then(() => {
          this.setState({
            uploading: false,
            uploadProgress: 0,
          });
          this.fetchProfile();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  handleCheck = (e) => {
    this.setState({
      maternityCenter: e.target.checked,
    });
  };

  handleProceduresCheck = (e) => {
    this.setState({
      cashlessProcedures: e.target.checked,
    });
  };

  setOtherDeonboardingReason = (e) => {
    this.setState({
      deOnboardingReason2: e.target.value,
    });
  };

  fetchProfile = () => {
    this.setState({ loading: true });
    fetchCenterBasicProfile(this.centerId)
      .then((res) => {
        const basicProfile = res;
        const isNetworkCenterStatus = res.isNetworkCenterStatus;
        if (isNetworkCenterStatus === 1) {
          this.props.sendDataToNCB(true);
        } else {
          this.props.sendDataToNCB(false);
        }
        const { centerDetails, welcomeMailLastTriggered, fulfilment } =
          basicProfile;
        let welcomeMailHistory;
        if (welcomeMailLastTriggered) {
          const { triggeredBy, triggeredAt } = welcomeMailLastTriggered;
          welcomeMailHistory = `last triggered by ${triggeredBy} on ${triggeredAt}`;
        }
        this.setState({
          title: centerDetails.title || '',
          address: centerDetails.address || '',
          locality: centerDetails.locality || '',
          city: centerDetails.city || '',
          pincode: centerDetails.pincode || null,
          state: centerDetails.state || '',
          latitude: centerDetails.latitude || '',
          longitude: centerDetails.longitude || '',
          contactNumber: centerDetails.contactNumber || '',
          referenceId: centerDetails.referenceId || '',
          description: centerDetails.description || '',
          servingSince: centerDetails.servingSince || '',
          bedCapacity: centerDetails.bedCapacity || '',
          type: centerDetails.type || 'clinic',
          opdStartsAt: centerDetails.opdStartsAt
            ? moment(centerDetails.opdStartsAt, 'HH:mm:ss')
            : moment('00:00:00', 'HH:mm:ss'),
          opdClosesAt: centerDetails.opdClosesAt
            ? moment(centerDetails.opdClosesAt, 'HH:mm:ss')
            : moment('00:00:00', 'HH:mm:ss'),
          networkSource: centerDetails.networkSource || 'Visit Onboarded',
          active: centerDetails.active || 0,
          profileImage: centerDetails.profileImage || '',
          slug: centerDetails.slug,
          sanitisationStatus: centerDetails.sanitisationStatus || 'pending',
          showRequest: centerDetails.showCenterRequests || 0,
          maternityCenter: centerDetails.maternityCenter || false,
          deOnboardedOn: centerDetails.deOnboardedOn || null,
          anyDoctorFlowStatus: centerDetails.anyDoctorFlowStatus || false,
          empanelStatus:
            centerDetails.empanellmentStatus == 'empanelled' ? true : false,
          prebookCenter: centerDetails.prebookedCentre ? true : false,
          welcomeMailTriggerHistory: welcomeMailHistory || null,
          paymentCycle: (fulfilment && fulfilment.paymentCycle) || null,
          empanelUserStatus: centerDetails.empanelUserStatus ? true : false,
          placeId: centerDetails.placeId || '',
          dentalNetwork: centerDetails.dentalNetwork ? true : false,
          dentalPartnerId: centerDetails.dentalPartnerId || null,
        });
        const currentDate = moment();
        const deOnboardedDate = moment(this.state.deOnboardedOn).format(
          'YYYY-MM-DD'
        );
        const diff = currentDate.diff(deOnboardedDate, 'days');
        this.setState({
          dateDifference: diff,
        });
        console.log('difference in date', diff, deOnboardedDate);
        // if (this.state.deOnboardedOn && this.state.)
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  fetchSanitisationSpoc() {
    this.setState({ loading: true });
    fetchLastSanitisationSpoc(this.centerId)
      .then((resp) => {
        const spocName = resp.spocName;
        console.log('\nSanitisation Spoc: ', spocName);
        this.setState({ sanitisationSpoc: spocName });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  removeProfilePic = () => {
    removeCenterProfilePic(this.centerId)
      .then(() => {
        this.fetchProfile();
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  fetchStates = () => {
    fetchCenterStates().then((res) => {
      console.log({ res }, 'Response');
      this.setState({
        states: res.data,
      });
    });
  };

  fetchDentalPartners = () => {
    getDentalPartners()
      .then((response) => {
        if (response.body.message === 'success') {
          this.setState({ dentalPartners: response.body.data });
        }
      })
      .catch((err) => {
        console.log({ err }, '[fetchDentalPartners] - backend may not be deployed yet');
      });
  };

  submit = (value) => {
    const { history } = this.props;
    const {
      title,
      address,
      locality,
      city,
      state,
      latitude,
      longitude,
      pincode,
      contactNumber,
      referenceId,
      description,
      servingSince,
      bedCapacity,
      type,
      opdStartsAt,
      opdClosesAt,
      networkSource,
      sanitisationStatus,
      showRequest,
      maternityCenter,
      anyDoctorFlowStatus,
      placeId,
      dentalPartnerId,
      dentalNetwork,
    } = this.state;
    const centerDetails = {
      centerId: this.centerId !== -1 ? this.centerId : undefined,
      title,
      address,
      locality,
      city,
      state,
      latitude,
      longitude,
      pincode,
      contactNumber,
      referenceId,
      description,
      servingSince,
      bedCapacity,
      type,
      opdStartsAt: opdStartsAt.format('HH:mm:ss'),
      opdClosesAt: opdClosesAt.format('HH:mm:ss'),
      networkSource: networkSource || undefined,
      sanitisationStatus,
      showRequest: showRequest,
      maternityCenter: maternityCenter ? 1 : 0,
      anyDoctorFlowStatus: anyDoctorFlowStatus,
      placeId: placeId,
      dentalPartnerId: dentalPartnerId || null,
      dentalNetwork: dentalNetwork ? 1 : 0,
    };
    const regexPhone = /^[0-9]{10}$/;
    // if (contactNumber && !regexPhone.test(contactNumber)) {
    //   const data = {
    //     errorMessage: 'Please provide a valid phone number',
    //     message: 'serverError',
    //   };
    //   const err = new Error('Invalid response');
    //   err.data = data;
    //   showError(err);
    //   return;
    // }
    if (value == 'featured') {
      centerDetails.showRequest = showRequest ? 0 : 1;
    }
    if (value == 'anyDoctorRequest') {
      centerDetails.anyDoctorFlowStatus = anyDoctorFlowStatus ? false : true;
    }
    // axios.get(`http://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&sensor=true`)
    //   .then((result) => {
    //     console.log(result, 'pincode details ')
    //   })
    this.setState({ loading: true });
    if (this.centerId && this.centerId !== -1) {
      updateNetworkCenterProfile(centerDetails)
        .then(() => {
          this.fetchProfile();
          const title = `Successfully updated center details!`;
          this.handleModalSuccess(title);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    } else {
      createNetworkCenterProfile(centerDetails)
        .then((res) => {
          this.centerId = res.centerId;
          // Redirect to network center screen
          const title = `Successfully created center!`;
          this.handleModalSuccess(title);
          history.replace(`/center-profile/${this.centerId}`);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  handleModalSuccess = (title) => {
    const seconds = 5;
    const modal = Modal.success({
      title: title,
    });

    setTimeout(() => {
      modal.destroy();
    }, seconds * 1000);
  };

  handleFeaturedCheck = (e) => {
    this.submit('featured');
  };

  handleAnyDoctorFlowCheck = (e) => {
    this.submit('anyDoctorRequest');
  };

  handleEmpanelmentChange = (e) => {
    const body = {
      empanellmentStatus: e ? 'empanelled' : 'depanelled',
      centerId: this.centerId,
      prebookCenter: this.state.prebookCenter,
    };
    console.log(e);
    updateNetworkCenterEmpanelment(body)
      .then(() => {
        this.fetchProfile();
        const title = `Successfully updated center details!`;
        this.handleModalSuccess(title);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleEmpanelUserStatusChange = (e) => {
    const body = {
      empanelUserStatus: e ? 1 : 0,
      centerId: this.centerId,
    };
    console.log(e);
    updateNetworkCenterEmpanelUserStatus(body)
      .then(() => {
        this.fetchProfile();
        const title = `Successfully updated center details!`;
        this.handleModalSuccess(title);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
        window.location.reload();
      });
  };

  handlePrebookCenterChange = (e) => {
    const body = {
      empanellmentStatus: this.state.empanelStatus,
      centerId: this.centerId,
      prebookCenter: e ? true : false,
    };
    console.log(e);
    updateNetworkCenterEmpanelment(body)
      .then(() => {
        this.fetchProfile();
        const title = `Successfully updated center details!`;
        this.handleModalSuccess(title);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  checkNetworkCenterActivityForPrebook = async () => {
    const response = await checkCenterNetworkActivity(this.centerId);
    console.log(response);
    if (response.centerActivity && response.centerActivity.length > 0) {
      this.setState({
        isCenterActivityAvailable: true,
        prebookModalLoader: false,
      });
    } else {
      this.setState({
        isCenterActivityAvailable: false,
        prebookModalLoader: false,
        callCenterNumber: '',
        website: '',
      });
    }
  };

  handlePrebookRequestModal = (e) => {
    if (this.state.prebookCenter) {
      // remove from prebook center list without any checks
      this.handlePrebookCenterChange(e);
      return;
    } else {
      //open modal for prebook checks
      this.setState({
        prebookCenterRequestModal: !this.state.prebookCenterRequestModal,
        prebookModalLoader: true,
      });
      this.checkNetworkCenterActivityForPrebook();
    }
  };

  onStatusChange = (checked) => {
    console.log('[statusSwitch]' + `switch to ${checked}`);
    if (!checked) {
      this.setState({
        approvalRequestModal: true,
        loading: false,
        active: 0,
      });
    } else {
      changeNetworkCenterStatus(this.centerId, checked)
        .then(() => {
          this.fetchProfile();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }

    // if (this.centerId && this.centerId !== -1) {
    //   changeNetworkCenterStatus(this.centerId, checked)
    //     .then(() => {
    //       this.fetchProfile();
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     })
    //     .finally(() => {
    //       this.setState({ loading: false });
    //     });
    // } else {
    //   message.info('First create a network center and then mark it active', 3);
    // }
  };

  opdStartsAtChange = (e) => {
    if (e) {
      console.log({ e: e.format('HH:mm:ss') });
      this.setState({
        opdStartsAt: e,
      });
    } else {
      this.setState({
        opdStartsAt: moment('00:00:00', 'HH:mm:ss'),
      });
    }
  };

  opdEndAtChange = (e) => {
    if (e) {
      console.log({ e: e.format('HH:mm:ss') });
      this.setState({
        opdClosesAt: e,
      });
    } else {
      this.setState({
        opdClosesAt: moment('00:00:00', 'HH:mm:ss'),
      });
    }
  };

  handleSubmitapproval = () => {
    const body = {
      doctorId: null,
      centerId: this.props.centerId,
      centerName: this.state.title,
      active: null,
      opdCharges: null,
      onlineOpdCharges: null,
      offlineDiscount: null,
      offlineDiscountOperation: null,
      onlineDiscount: null,
      onlineDiscountOperation: null,
      fDiscount: null,
      fDiscountOperation: null,
      fDays: null,
      onlineFDiscount: null,
      onlineFDiscountOperation: null,
      onlineFDays: null,
      fulfilmentType: null,
      status: null,
      onlineCorporatePayout: null,
      onlineRetailPayout: null,
      telehealth: null,
      priceChangeReason:
        this.state.deOnboardingReason === 'Others'
          ? this.state.deOnboardingReason2
          : this.state.deOnboardingReason,
      previousData: null,
      requestType: 'center-deOnboarding',
    };
    return sendRequestForDoctorDetailsChanges(body).then(() => {
      this.setState({
        approvalRequestModal: false,
      });
    });
  };

  handleCancelModal = () => {
    this.setState({
      approvalRequestModal: false,
    });
  };

  sanitisationStatusHandler = (e) => {
    this.setState({ sanitisationStatus: e });
  };

  handleNetworkSourceChange = (value) => {
    console.log('Network Source:', value);
    this.setState({
      networkSource: value,
    });
  };

  // latlongAddress = (e) => {
  //   //Link.state(this, 'longitude')
  //   if (e.key === 'Enter') {
  //     console.log('enter press here! ');
  //     console.log(e.target);
  //     const latitude = selectedLocation.lat;
  //     const longitude = selectedLocation.lat;

  //     createAddressCenterLatLong(latitude, longitude)
  //       .then((res) => {
  //         console.log(res.data.results[0]);
  //         const address = res.data.results[0];
  //         this.setState({
  //           state: address.state,
  //         });
  //         this.setState({
  //           locality: address.locality,
  //         });

  //         this.setState({
  //           address: address.formatted_address,
  //         });
  //         this.setState({
  //           pincode: address.pincode,
  //         });
  //         console.log(this.state.pincode);

  //         if (address.city.length !== 0) {
  //           this.setState({
  //             city: address.city,
  //           });
  //         } else {
  //           this.setState({
  //             city: address.district,
  //           });
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // };

  handleCallCenterBlur = () => {
    const { callCenterNumber } = this.state;

    // Check if the input contains only digits and is at most 12 digits
    if (!/^\d+$/.test(callCenterNumber)) {
      this.setState({
        callCenterNumberError: 'Call Center Number must contain only digits.',
      });
    } else if (callCenterNumber.length < 10 || callCenterNumber.length > 12) {
      this.setState({
        callCenterNumberError:
          'Call Center Number must be between 10 and 12 digits.',
      });
    } else {
      this.setState({ callCenterNumberError: '' });
    }
  };

  handleWebsiteBlur = async () => {
    const { website } = this.state;

    // Domain validation regex
    const domainPattern =
      /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}\/?$/;

    // Add protocol if missing
    let formattedWebsite = website;
    if (!website.startsWith('http://') && !website.startsWith('https://')) {
      formattedWebsite = `https://${website}`;
    }

    // RegExp check before fetch
    if (!domainPattern.test(formattedWebsite)) {
      this.setState({
        websiteError: 'Invalid domain format.',
      });
      return;
    }
  };

  // Update input change handlers
  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, websiteError: '' });
  };

  // State update for file upload
  handleFileUpload = (e) => {
    console.log('handleFileUpload', e);
    this.setState({ selfBookSnapShot: e.target.files[0] });
    const documentCategory = 14; //for selfbook docs
    return uploadMouDocument(this.centerId, documentCategory, e.target.files[0])
      .then((resInfo) => {
        console.log(resInfo, 'uploadMouDocument response');
        const mouLogId = resInfo.result.mouLogId;
        this.setState({
          mouLogIds: mouLogId,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  isOkButtonDisabled = () => {
    const {
      callCenterNumber,
      website,
      isCenterActivityAvailable,
      userConsent,
      selfBookSnapShot,
      callCenterNumberError,
      websiteError,
      mouLogIds,
    } = this.state;
    const contactInfoProvided = callCenterNumber || website;
    const consentRequired = !isCenterActivityAvailable ? userConsent : true;
    const hasErrors = callCenterNumberError || websiteError;

    return !(contactInfoProvided && consentRequired && mouLogIds) || hasErrors;
  };

  handleCenterActivation = async () => {
    const body = {
      centerId: this.centerId,
      mouCategory: 14, //forselfbook
      mouStatus: 1,
      mouLogIds: this.state.mouLogIds,
      documentType: 'center-documents',
      consentRequired: this.state.userConsent,
      callCenterNumber: this.state.callCenterNumber,
      websiteUrl: this.state.website,
    };
    // Check for individual errors and display appropriate alert messages
    if (this.state.websiteError) {
      alert('The website URL is invalid. Please correct it before proceeding.');
      return;
    }

    if (this.state.callCenterNumberError) {
      alert(
        'The call center number is invalid. Please correct it before proceeding.'
      );
      return;
    }

    const response = await centerActivationForPrebook(body);
    if (response.message == 'success') {
      this.fetchProfile();
      this.setState({
        prebookCenterRequestModal: false,
      });
      const title = `Successfully updated center details!`;
      this.handleModalSuccess(title);
    }
  };
  handleCancelWelcomeMailModal = () => {
    this.setState({
      openWelcomeMailSendModal: false,
    });
  };

  sendWelcomeMail = () => {
    this.setState({ loading: true });

    sendWelcomeMailToCenter(
      this.centerId,
      this.state.centerUserName,
      this.state.centerLogInPassword
    )
      .then((res) => {
        console.log(' sendWelcomeMailToCenter response ', res);
        this.fetchProfile();
      })
      .catch((err) => {
        console.log('error in sendWelcomeMailToCenter', err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  handleModalOkay = () => {
    this.handleCancelWelcomeMailModal();
    if (!this.state.centerUserName || !this.state.centerLogInPassword) {
      const data = {
        errorMessage:
          'Please provide a valid user name & password to trigger welcome mail',
        message: 'serverError',
      };
      const err = new Error('Invalid response');
      err.data = data;
      showError(err);
      return;
    }
    this.sendWelcomeMail();
  };

  sendMailModal = () => (
    <Modal
      title="Enter KEA Portal Credentails"
      visible={this.state.openWelcomeMailSendModal}
      onOk={this.handleModalOkay}
      onCancel={this.handleCancelWelcomeMailModal}
    >
      <Text>User Name</Text>
      <AntInput
        placeholder="User Name"
        value={this.state.centerUserName}
        onChange={(e) =>
          this.setState({
            centerUserName: e.target.value,
          })
        }
      />
      <Text>Enter Password</Text>
      <AntInput
        placeholder="Enter Password"
        value={this.state.centerLogInPassword}
        onChange={(e) =>
          this.setState({
            centerLogInPassword: e.target.value,
          })
        }
      />
    </Modal>
  );

  handleOpenWelcomeMailModal = () => {
    this.setState({
      openWelcomeMailSendModal: true,
    });
  };

  fetchPlaceDetailsFromId = (placeId) => {
    if (!window.google || !window.google.maps || !window.google.maps.places) {
      console.log('Waiting for Google Maps API to load...');
      setTimeout(() => this.fetchPlaceDetailsFromId(placeId), 1000);
      return;
    }

    const service = new window.google.maps.places.PlacesService(
      document.createElement('div')
    );

    const request = {
      placeId,
      fields: ['geometry', 'name', 'formatted_address']
    };

    service.getDetails(request, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && place.geometry) {
        const location = place.geometry.location;
        this.setState({
          selectedLocation: {
            lat: location.lat(),
            lng: location.lng(),
          },
          // Update the search term with the place name and address
          searchTerm: place.name && place.formatted_address
            ? `${place.name}, ${place.formatted_address}`
            : place.formatted_address || ''
        });
      } else {
        console.error('Failed to fetch place details:', status);
        message.error('Failed to load location details');
      }
    });
  };

  // You may also want to update handlePlaceIdModal to ensure state is properly set
  handlePlaceIdModal = () => {
    console.log('handlePlaceIdModal called');
    const { placeId, placeIdModal } = this.state;

    if (!placeIdModal) {
      // When opening the modal
      this.setState({
        placeIdModal: true
      }, () => {
        // Only fetch details if placeId exists
        if (placeId) {
          this.fetchPlaceDetailsFromId(placeId);
        }
      });
    } else {
      // When closing the modal
      this.setState({
        placeIdModal: false
      });
    }
  };





  fetchSuggestions = (query) => {
    if (!query) {
      this.setState({ suggestions: [] });
      return;
    }

    const service = new window.google.maps.places.AutocompleteService();
    const request = {
      input: query,
      locationRestriction: {
        west: 68.1,
        north: 37.6,
        east: 97.4,
        south: 8.1,
      },
      language: 'en-US',
      region: 'in',
    };

    service.getPlacePredictions(request, (predictions, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        console.log(predictions, 'predictions');
        this.setState({ suggestions: predictions || [] });
      }
    });
  };

  handleSearchChange = (event) => {
    const query = event.target.value;
    this.setState({ searchTerm: query });
    this.fetchSuggestions(query);
  };

  fetchPlaceDetails = async (placeId) => {
    const service = new window.google.maps.places.PlacesService(
      document.createElement('div')
    );

    service.getDetails({ placeId }, (place, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK) {
        console.log('Full Place Details:', place);

        const addressComponents = place.address_components || [];
        let details = {
          address: `${place.name}, ${place.formatted_address}` || '',
          formatted_address: place.formatted_address || '',
          sublocality: '',
          pincode: place.postal_code || '',
          centerName: place.name || '',
          locality: '',
          city: '',
          state: '',
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          placeId: placeId,
        };

        addressComponents.forEach((comp) => {
          if (comp.types.includes('postal_code'))
            details.pincode = comp.long_name;
          if (
            comp.types.includes('sublocality') ||
            comp.types.includes('locality')
          )
            details.locality = comp.long_name;
          if (
            comp.types.includes('sublocality_level_1') ||
            comp.types.includes('sublocality_level_2') ||
            comp.types.includes('neighborhood') ||
            comp.types.includes('locality')
          ) {
            details.sublocality = comp.long_name;
          }
          if (comp.types.includes('administrative_area_level_2'))
            details.city = comp.long_name;
          if (comp.types.includes('administrative_area_level_1'))
            details.state = comp.long_name;
        });

        this.setState({
          selectedLocation: details,
          placeId: placeId,
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
          city: details.locality,
          state: details.state,
          address: details.formatted_address,
          locality: details.sublocality,
          pincode: details.pincode,
        }); // Use setState in class components
      } else {
        console.error('Place Details API failed:', status);
      }
    });
  };

  handlePlaceSelected = (suggestion) => {
    console.log(suggestion, 'suggestion');
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ placeId: suggestion.place_id }, (results, status) => {
      if (status === 'OK' && results.length > 0) {
        (async () => {
          const place = results[0];
          console.log(place.place_id, 'here');

          await this.fetchPlaceDetails(place.place_id);
          this.setState({ searchTerm: place.description });
        })();
      }
    });

    this.setState({ suggestions: [] });
  };
  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selectedLocation !== prevState.selectedLocation &&
      this.state.selectedLocation &&
      this.state.selectedLocation.address
    ) {
      this.setState({
        searchTerm: this.state.selectedLocation.address,
      });
    }
  }

  render() {
    const {
      loading,
      networkSource,
      type,
      active,
      opdStartsAt,
      opdClosesAt,
      states,
      uploading,
      state,
      profileImage,
      slug,
      sanitisationStatus,
      sanitisationSpoc,
      showRequest,
      approvalRequestModal,
      dateDifference,
      anyDoctorFlowStatus,
      prebookCenterRequestModal,
      websiteError,
      callCenterNumberError,
      placeIdModal,
      searchTerm,
      suggestions,
      selectedLocation,
      placeId,
    } = this.state;
    const titleInputLink = Link.state(this, 'title');
    const addressInputLink = Link.state(this, 'address');
    const localityInputLink = Link.state(this, 'locality');
    const cityInputLink = Link.state(this, 'city');
    const stateInputLink = Link.state(this, 'state');
    const latitudeInputLink = Link.state(this, 'latitude');
    const longitudeInputLink = Link.state(this, 'longitude');
    const contactNumberInputLink = Link.state(this, 'contactNumber');
    const descriptionInputLink = Link.state(this, 'description');
    const servinceSinceInputLink = Link.state(this, 'servingSince');
    const bedCapacityInputLink = Link.state(this, 'bedCapacity');
    const referenceIdInputLink = Link.state(this, 'referenceId');
    const placeIdInputLink = Link.state(this, 'placeId');
    // const opdStartsAtInputLink = Link.state(this, 'opdStartsAt');
    // const opdClosesAtInputLink = Link.state(this, 'opdClosesAt');
    const defaultPosition = {
      lat:
        selectedLocation && parseFloat(selectedLocation.lat)
          ? parseFloat(selectedLocation.lat)
          : 28.5681,
      lng:
        selectedLocation && parseFloat(selectedLocation.lng)
          ? parseFloat(selectedLocation.lng)
          : 77.3162,
    };

    return (
      <Row type="flex" gutter={16}>
        {this.sendMailModal()}
        {this.state.uploading && (
          <Col span={24}>
            <StyledUploadingComponent
              uploadProgress={`${this.state.uploadProgress}%`}
              borderRadius={0}
            />
          </Col>
        )}
        <Col span={24}>
          <TitleText>Network Center Profile</TitleText>
        </Col>
        {loading ? (
          <Spin spinning={loading} />
        ) : (
          <>
            <Col xs={{ order: 2, span: 24 }} md={{ order: 1, span: 12 }}>
              <Row gutter={[16, 16]}>
                {this.state.deOnboardedOn == null ||
                  this.state.dateDifference > 30 ||
                  this.state.dateDifference !== 0 ? (
                  <Col span={12}>
                    <LabelText>Status</LabelText>
                    {
                      <Switch
                        checked={active}
                        disabled={!this.props.isCenterEnabled}
                        onChange={this.onStatusChange}
                      />
                    }
                  </Col>
                ) : (
                  <Col span={12}>
                    <span style={{ color: '#FF754C' }}>
                      *this center will be off-boarded in{' '}
                      {30 - parseInt(this.state.dateDifference)} days
                    </span>
                  </Col>
                )}

                {/* <Col span={12}>
                  <LabelText>Featured</LabelText>
                  <Switch
                    checked={showRequest}
                    onChange={this.handleFeaturedCheck}
                  />
                </Col> */}
                <Col span={12}>
                  <LabelText>Any Doctor Flow</LabelText>
                  <Switch
                    checked={anyDoctorFlowStatus}
                    onChange={this.handleAnyDoctorFlowCheck}
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Empanellment Status</LabelText>
                  <Switch
                    checked={this.state.empanelStatus}
                    onChange={this.handleEmpanelmentChange}
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Special empanelment</LabelText>
                  <Switch
                    checked={this.state.empanelUserStatus}
                    onChange={this.handleEmpanelUserStatusChange}
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Prebook Centre</LabelText>
                  <Switch
                    checked={this.state.prebookCenter}
                    onChange={this.handlePrebookRequestModal}
                  />
                </Col>
                <Col span={13}>
                  <LabelText>Select Hospital/Clinic</LabelText>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: '10px',
                    }}
                  >
                    <button
                      style={{
                        height: '44px',
                        borderRadius: '6px',
                        border: 'none',
                        backgroundColor: '#1890ff',
                        color: '#fff',
                        cursor: 'pointer',
                      }}
                      onClick={this.handlePlaceIdModal}
                    >
                      Select
                    </button>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={placeIdInputLink}
                      placeholder="PlaceId"
                      disabled
                    />
                  </div>
                </Col>
                <Col span={24}>
                  <LabelText>Center Name</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={titleInputLink}
                    placeholder="Name"
                  />
                </Col>
                {/* {this.state.validationErrors.dependentName ? (
                <ValidationText>
                  {this.state.validationErrors.dependentName.errorMessage}
                </ValidationText>
              ) : null} */}
                <Col span={24}>
                  <LabelText>Center Address</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={addressInputLink}
                    placeholder="Address"
                    disabled
                  />
                </Col>

                <Col span={24}>
                  <LabelText>Locality</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={localityInputLink}
                    placeholder="Locality"
                    disabled
                  />
                </Col>

                <Col span={12}>
                  <LabelText>City</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={cityInputLink}
                    placeholder="City"
                    disabled
                  />
                </Col>

                <Col span={12}>
                  <LabelText>State</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={stateInputLink}
                    placeholder="State"
                    disabled
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Contact Number</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={contactNumberInputLink}
                    placeholder="Contact Number"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Description</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={descriptionInputLink}
                    placeholder="Description"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Serving Since</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={servinceSinceInputLink}
                    placeholder="Serving Since"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Bed Capacity</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={bedCapacityInputLink}
                    placeholder="Bed Capacity"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Type</LabelText>
                  <Select
                    style={{ width: '100%' }}
                    value={type}
                    defaultValue="clinic"
                    onChange={(e) => this.setState({ type: e })}
                  >
                    <Option value="clinic">Clinic</Option>
                    <Option value="hospital">Hospital</Option>
                  </Select>
                </Col>
                <Col span={12}>
                  <LabelText>Network Source</LabelText>
                  <Select
                    style={{ width: '100%' }}
                    value={networkSource}
                    // disabled
                    defaultValue="Visit Onboarded"
                    onChange={this.handleNetworkSourceChange}
                  >
                    <Option value="1">Practo</Option>
                    <Option value="2">CrediHealth</Option>
                    <Option value="3">Medibuddy</Option>
                    <Option value="4">Visit Online</Option>
                    <Option value="5">DocPrime</Option>
                    <Option value="6">Visit Onboarded</Option>
                    <Option value="7">Ayu Health</Option>
                    <Option value="8">Tatva</Option>
                  </Select>
                </Col>
                <Col span={12}>
                  <LabelText>OPD Starts at</LabelText>
                  {/* <StyledInputBox
                    className="visit-input"
                    valueLink={opdStartsAtInputLink}
                    placeholder="OPD Starts at"
                  /> */}
                  <TimePicker
                    defaultValue={opdStartsAt}
                    use12Hours
                    format="HH:mm a"
                    onChange={this.opdStartsAtChange}
                  />
                </Col>
                <Col span={12}>
                  <LabelText>OPD Closes at</LabelText>
                  {/* <StyledInputBox
                    className="visit-input"
                    valueLink={opdClosesAtInputLink}
                    placeholder="OPD Closes at"
                  /> */}
                  <TimePicker
                    defaultValue={opdClosesAt}
                    use12Hours
                    format="hh:mm a"
                    onChange={this.opdEndAtChange}
                  />
                </Col>
                <Col span={12}>
                  <LabelText style={{ width: '250px' }}>
                    Sanitisation Status
                  </LabelText>
                  <Select
                    style={{ width: '150px' }}
                    value={sanitisationStatus}
                    onChange={this.sanitisationStatusHandler}
                  >
                    <Option value="pending">Pending</Option>
                    <Option value="in-process">In-process</Option>
                    <Option value="sanitised">Sanitised</Option>
                  </Select>
                </Col>
                <Col span={12}>
                  <LabelText>Sanitisation SPOC</LabelText>
                  <AntInput value={sanitisationSpoc} disabled />
                </Col>
                <Col span={24}>
                  <span>
                    <Checkbox
                      onChange={this.handleCheck}
                      checked={this.state.maternityCenter}
                    >
                      Maternity Center
                    </Checkbox>
                    <Checkbox
                      onChange={this.handleProceduresCheck}
                      checked={this.state.cashlessProcedures}
                    >
                      Cashless Procedures
                    </Checkbox>
                    <Checkbox
                      checked={this.state.dentalNetwork}
                      onChange={(e) => this.setState({ dentalNetwork: e.target.checked, dentalPartnerId: e.target.checked ? this.state.dentalPartnerId : null })}
                    >
                      Dental Network
                    </Checkbox>
                  </span>
                  {this.state.dentalNetwork && (
                    <Select
                      showSearch
                      size="small"
                      style={{ width: '200px', marginLeft: '16px' }}
                      placeholder="Select dental partner"
                      value={this.state.dentalPartnerId}
                      onChange={(value) => this.setState({ dentalPartnerId: value })}
                      allowClear
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.state.dentalPartners.map((p) => (
                        <Select.Option key={p.partnerId} value={p.partnerId}>
                          {p.partnerName}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </Col>
                <Col span={12}>
                  <LabelText>Reference id</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={referenceIdInputLink}
                    placeholder="Reference id"
                  />
                </Col>
                <Col span={24}>
                  <Button
                    block
                    type="primary"
                    size="large"
                    onClick={this.submit}
                  >
                    <ButtonText>Submit</ButtonText>
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col xs={{ order: 1, span: 24 }} md={{ order: 2, span: 12 }}>
              <Row type="flex" justify="center">
                <Col span={24} style={{ textAlign: 'center' }}>
                  <TitleText>Upload Center Logo</TitleText>
                  <input
                    type="file"
                    id="imageAttachment"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={this.handleAttachment}
                  />
                  {this.centerId !== -1 && !uploading ? (
                    <>
                      <ProfileImageTappable
                        disabled
                        onTap={() =>
                          document.querySelector('#imageAttachment').click()
                        }
                      >
                        <ProfileImage src={profileImage || doctorPlaceholder} />
                      </ProfileImageTappable>
                      {profileImage && (
                        <Button onClick={this.removeProfilePic} icon="stop">
                          Remove Logo
                        </Button>
                      )}
                    </>
                  ) : (
                    <TitleText>First upload basic details</TitleText>
                  )}
                </Col>
              </Row>
              {slug && (
                <Row justify="center">
                  <Col
                    span={24}
                    style={{ textAlign: 'center', marginTop: '40px' }}
                  >
                    <TitleText style={{ fontSize: '24px' }}>Slug</TitleText>
                    <Text code>{slug}</Text>
                  </Col>
                </Row>
              )}
              <Row>
                <Col span={24} style={{ padding: '20px', margin: '20px' }}>
                  <Button
                    type="primary"
                    onClick={this.handleOpenWelcomeMailModal}
                  >
                    Send Welcome Mail
                  </Button>
                  {this.state.welcomeMailTriggerHistory ? (
                    <p style={{ margin: '5px' }}>
                      <span style={{ color: 'red' }}>
                        {this.state.welcomeMailTriggerHistory}
                      </span>
                    </p>
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
            </Col>
          </>
        )}
        <Modal
          title="Enter Reason for de-onboarding"
          visible={approvalRequestModal}
          onOk={this.handleSubmitapproval}
          onCancel={this.handleCancelModal}
        >
          <Select
            style={{ width: '100%', marginBottom: '10px' }}
            value={this.state.deOnboardingReason}
            defaultValue="Tie-up issues"
            onChange={(e) =>
              this.setState({
                deOnboardingReason: e,
              })
            }
          >
            <Option value="Tie-up issues">Tie-up issues</Option>
            <Option value="TDS Deduction">TDS Deduction</Option>
            <Option value="Center Permanently closed">
              Center Permanently closed
            </Option>
            <Option value="Payment Issues">Payment Issues</Option>
            <Option value="Others">Others</Option>
          </Select>
          {this.state.deOnboardingReason === 'Others' ? (
            <AntInput
              placeholder="Enter Reason"
              value={this.state.deOnboardingReason2}
              onChange={this.setOtherDeonboardingReason}
            />
          ) : null}
        </Modal>
        <Modal
          title="Verify Prebook Center Details"
          visible={prebookCenterRequestModal}
          onOk={this.handleCenterActivation}
          onCancel={this.handlePrebookRequestModal}
          okButtonProps={{ disabled: this.isOkButtonDisabled() }}
        >
          {/* Contact Information Inputs */}
          {this.state.prebookModalLoader ? (
            <div>Loading...</div>
          ) : (
            <>
              <div style={styles.inputContainer}>
                <label style={styles.label}>Call Center Number:</label>
                <input
                  type="number"
                  name="callCenterNumber"
                  value={this.state.callCenterNumber}
                  onChange={this.handleInputChange}
                  onBlur={this.handleCallCenterBlur} // Validate on focus out
                  placeholder="Enter call center number"
                  style={styles.input}
                />
                {callCenterNumberError && (
                  <div style={styles.error}>{callCenterNumberError}</div>
                )}
              </div>
              <div style={styles.inputContainer}>
                <label style={styles.label}>Website:</label>
                <input
                  type="text"
                  name="website"
                  value={this.state.website}
                  onChange={this.handleInputChange}
                  onBlur={this.handleWebsiteBlur} // Validate on focus out
                  placeholder="Enter website URL"
                  style={styles.input}
                />
                {websiteError && <div style={styles.error}>{websiteError}</div>}
              </div>
              {/* File Upload for Email Snapshot */}
              <div style={styles.inputContainer}>
                <label style={styles.label}>
                  Snapshot of Email Confirming Center Alignment:
                </label>
                <input
                  type="file"
                  accept="image/*,application/pdf"
                  onChange={this.handleFileUpload}
                  style={styles.input}
                />
              </div>
            </>
          )}

          <hr />

          {this.state.prebookModalLoader ? (
            <div>Loading...</div>
          ) : (
            <>
              {!this.state.isCenterActivityAvailable && (
                <p style={{ color: 'red' }}>
                  Error: Doctor practice details have not been updated in the
                  last 15 days.
                </p>
              )}
              <p>
                Ensure that the doctor details are up-to-date to enable
                self-booking for this center.
              </p>

              {/* Show consent checkbox only if isCenterActivityAvailable is false */}
              {!this.state.isCenterActivityAvailable && (
                <Checkbox
                  onChange={(e) =>
                    this.setState({ userConsent: e.target.checked })
                  }
                >
                  I confirm that the doctor list is up-to-date and I am
                  responsible for any issues.
                </Checkbox>
              )}
            </>
          )}
        </Modal>
        <Modal
          className="placeIdModal"
          visible={placeIdModal}
          onCancel={this.handlePlaceIdModal}
          footer={null}
        >
          <div>
            <h2>Choose hospital on map</h2>
            <LoadScript
              googleMapsApiKey={GOOGLE_MAPS_API_KEY}
              libraries={['places']}
              onLoad={() => {
                console.log('Google Maps API loaded');
                // If you have a placeId on initial load, you can fetch details here
                if (this.state.placeId) {
                  this.fetchPlaceDetailsFromId(this.state.placeId);
                }
              }}
            >
              <div style={{ width: '100%' }}>
                <div style={{ position: 'relative', marginBottom: '10px' }}>
                  <label>
                    Enter Name or Locate Hospital
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={this.state.searchTerm}
                    onChange={this.handleSearchChange}
                    placeholder="Search on Google Maps"
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                    }}
                  />
                  {suggestions.length > 0 && (
                    <ul
                      style={{
                        position: 'absolute',
                        top: '40px',
                        left: 0,
                        right: 0,
                        background: 'white',
                        border: '1px solid #ccc',
                        listStyle: 'none',
                        margin: 0,
                        padding: '10px',
                        maxHeight: '150px',
                        overflowY: 'auto',
                        zIndex: 10,
                        marginTop: '25px',
                      }}
                    >
                      {suggestions.map((suggestion) => (
                        <li
                          key={suggestion.place_id}
                          onClick={() => this.handlePlaceSelected(suggestion)}
                          style={{
                            padding: '5px',
                            cursor: 'pointer',
                          }}
                        >
                          {suggestion.description}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              <div style={{ marginBottom: '10px', height: '400px' }}>
                <GoogleMap
                  center={this.state.selectedLocation}
                  zoom={14}
                  mapContainerStyle={{
                    ...mapContainerStyle,
                    height: '400px', // Adjust height dynamically
                  }}
                // onClick={handleMapClick}
                >
                  {selectedLocation && (
                    <Marker
                      position={{
                        lat: parseFloat(selectedLocation.lat),
                        lng: parseFloat(selectedLocation.lng),
                      }}
                    />
                  )}
                </GoogleMap>
              </div>
            </LoadScript>
            <div style={{ textAlign: 'right', marginTop: '15px' }}>
              <button
                onClick={this.handlePlaceIdModal} // or a custom confirm handler
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#714FFF',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  width: '100%',
                }}
              >
                Choose Center
              </button>
            </div>
          </div>
        </Modal>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default withRouter(
  connect(mapStateToProps)(NetworkCenterBasicProfileScreen)
);
